module.exports = __webpack_public_path__ + "img/tal.96c86f86.png";